import groupBy from 'lodash/groupBy';
import { inject, observer } from 'mobx-react';
import React, { Fragment } from 'react';

const List = inject('lineStore', 'igStore')(
  observer(({ lineStore, igStore }) => {
    const { video } = lineStore.menu;
    const { toggleVideoList } = igStore;
    const games = video.games.filter(g => g.gid !== igStore.video.gid);
    const grouped = groupBy(games, g => g.sid);
    return (
      <div className="videoplayer-list">
        {igStore.video.title ? (
          <div
            className="videoplayer-list__item videoplayer-list__item--active"
            onClick={toggleVideoList}
          >
            {igStore.video.title}
          </div>
        ) : null}
        {Object.keys(grouped).map(sid => (
          <Fragment>
            <div className="videoplayer-list__item videoplayer-list__item--sport">
              {video.dict.sport[sid]}
              <span className={`f-s-ico-${sid}`} />
            </div>
            {grouped[sid].map(v => (
              <div
                className="videoplayer-list__item"
                onClick={() => {
                  toggleVideoList();
                  igStore.setGame({
                    id: v.gid,
                    stats: v.stats,
                    video: true,
                    video_type: [v.type],
                    sid,
                    c1: null,
                    c2: null,
                    score: null,
                  });
                }}
              >
                {v.name}
              </div>
            ))}
          </Fragment>
        ))}
      </div>
    );
  }),
);

export default List;



// WEBPACK FOOTER //
// ./src/components/videoplayer/list.js